import type { LocationQueryValue } from '#vue-router'

type QueryParams = {
  name: string
  value: LocationQueryValue | LocationQueryValue[]
}[]

export const useQueryParams = () => {
  const { query } = useRoute()

  const getByPrefix = (prefix: string) => {
    const params: QueryParams = []
    const normalizedPrefix = prefix.endsWith('_') ? prefix : `${prefix}_`

    Object.entries(query).forEach(([key, value]) => {
      if (key.startsWith(normalizedPrefix)) {
        params.push({
          name: key.slice(normalizedPrefix.length),
          value,
        })
      }
    })
    return params
  }

  return {
    getByPrefix,
  }
}
